import React, { useEffect } from 'react';

const Modal = ({ closeModal, handleDelete, modalTitle, modalBody, submitBtnLabel="Delete" }) => {
  
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        closeModal();
      }
    };
  
    window.addEventListener("keydown", handleKeyDown);
  
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [closeModal]);

  return (
    <div className="modal-content Create-new-group-popup">
      <div className="modal-header">
        <label>{modalTitle}</label>
        <i
          className="fa fa-times-circle cursor-pointer"
          aria-hidden="true"
          onClick={closeModal}
        ></i>
      </div>
      <div className="modal-body deletechat-modalbody">
        <h4>{modalBody}</h4>
      </div>
      <div className="modal-footer modal-footer-groupcreate">
        <div></div>
        <div>
          <button className="btn btn-primary" onClick={closeModal}>
            {'Back'}
          </button>
          <button className="btn btn-danger" onClick={handleDelete}>
            {submitBtnLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
